// extracted by mini-css-extract-plugin
export var cartContainer = "_id-4";
export var gray = "_id-1";
export var itemContainer = "_id-2";
export var itemDetails = "_id-3";
export var strong = "_id-0";